import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
    // Customer values reference counterparty ids (the party being billed),
    // so this reuses the same counterparties list as RuleCounterpartyAction.
    counterparties: Counterparty[];
}

export const RuleCustomerAction: React.FC<Props> = ({
    value,
    counterparties,
}) => {
    const customer = counterparties.find((c) => c.id === value);

    if (!customer) {
        return null;
    }

    return (
        <RuleTagRow
            label="Assign billable customer"
            type="action"
            values={[customer.name]}
        />
    );
};
